import { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import type { SessionResponse } from "../shared/types";
import { Layout } from "./components/Layout";
import { readClientSession } from "./lib/client-session";
import { CoursePage } from "./pages/CoursePage";
import { CoursesByMedianPage } from "./pages/CoursesByMedianPage";
import { DepartmentPage } from "./pages/DepartmentPage";
import { DepartmentsPage } from "./pages/DepartmentsPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { HomePage } from "./pages/HomePage";
import { LoginPage } from "./pages/LoginPage";
import { ProfessorPage } from "./pages/ProfessorPage";
import { ProfessorsPage } from "./pages/ProfessorsPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { SearchPage } from "./pages/SearchPage";
import { SignupPage } from "./pages/SignupPage";
import { VerifyPage } from "./pages/VerifyPage";

export function App() {
  const [session, setSession] = useState<SessionResponse["user"]>(null);

  async function refreshSession() {
    setSession(readClientSession());
  }

  useEffect(() => {
    void refreshSession();
  }, []);

  return (
    <Routes>
      <Route element={<Layout session={session} refreshSession={refreshSession} />}>
        <Route index element={<HomePage />} />
        <Route path="/departments" element={<DepartmentsPage />} />
        <Route path="/departments/:code" element={<DepartmentPage />} />
        <Route path="/courses-by-median" element={<CoursesByMedianPage />} />
        <Route path="/median" element={<Navigate to="/courses-by-median/" replace />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/professors" element={<ProfessorsPage />} />
        <Route path="/professor/:slug" element={<ProfessorPage session={session} />} />
        <Route path="/course/:slug" element={<CoursePage session={session} />} />
        <Route path="/login" element={<LoginPage refreshSession={refreshSession} session={session} />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage refreshSession={refreshSession} />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/verify" element={<VerifyPage refreshSession={refreshSession} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
